/**
 * Check if a user has admin privileges based on their userType
 * @param user - The user object with userType field
 * @returns true if the user's type is ADMIN
 */
export const isAdmin = (user: { userType?: string | null } | undefined | null): boolean => {
  return user?.userType?.toUpperCase() === 'ADMIN';
};